const RF = {

    state: {
        model: "aura",
        type: "onetime",
        years: 2
    },

    init() {

        this.bindEvents();
        this.refreshSelection();

    },

    bindEvents() {

        const self = this;

        // ============================
        // MODEL
        // ============================

        $(document).on("click", ".rf-model", function () {

            $(".rf-model").removeClass("active");
            $(this).addClass("active");

            RF.state.model = $(this).data("model");

            RF.refreshSelection();

        });

        // ============================
        // DELIVERY
        // ============================

        $(document).on("click", ".rf-delivery", function () {

            $(".rf-delivery").removeClass("active");
            $(this).addClass("active");

            RF.state.type = $(this).data("type");
            if (RF.state.type !== "onetime" && RF.state.years === 0) {
                RF.state.years = 2;
            }
            RF.refreshSelection();

        });

        // ============================
        // PAYMENT PLAN
        // ============================

        $(document).on("change", ".rf-payment-select", function () {

            self.state.years = parseInt($(this).find(":selected").data("years"));

            self.refreshSelection();

        });

    },

    refreshSelection() {

        const paymentWrapper = $(".rf-payment-wrapper");

        if (this.state.type === "onetime") {
            paymentWrapper.addClass("hide");
            this.state.years = 0;
        } else {
            paymentWrapper.removeClass("hide");
        }
        // ==========================================
        // MASTER LIST
        // ==========================================

        console.log("Current state:", this.state);

        document.querySelectorAll(".rf-master-item").forEach(el => {
            console.log({
                model: el.dataset.model,
                type: el.dataset.type,
                years: el.dataset.years,
                variant: el.dataset.variant
            });
        });

        let selector =
            `.rf-master-item[data-model="${this.state.model}"]` +
            `[data-type="${this.state.type}"]`;

        if (this.state.type !== "onetime") {
            selector += `[data-years="${this.state.years}"]`;
        }


        console.log("Looking for:", selector);

        const item = document.querySelector(selector);

        const MODEL_LABELS = {
            aura: "Aura",
            vortex: "Vortex",
            vortexpro: "Vortex Pro"
        };
        const subtitle = document.querySelector(".product-single__title .subtitle");

        if (subtitle) {
            subtitle.textContent =
                MODEL_LABELS[this.state.model];
        }

        /* show dropdown */
        // ==========================================
        // PAYMENT PLAN
        // ==========================================

        $(".rf-variant-option").addClass("hide");

        if (this.state.type !== "onetime") {

            const wrapper = $(
                '.rf-variant-option[data-type="' + this.state.type + '"]'
            );

            wrapper.removeClass("hide");

            const select = wrapper.find("select");

            select.empty();

            document.querySelectorAll(
                `.rf-master-item[data-model="${this.state.model}"][data-type="${this.state.type}"]`
            ).forEach(masterItem => {

                const years = Number(masterItem.dataset.years);

                select.append(`
                    <option
                        value="${masterItem.dataset.variant}"
                        data-years="${years}"
                        data-price="${masterItem.dataset.price}"
                        data-frequency="${masterItem.dataset.frequency}"
                        ${years === this.state.years ? "selected" : ""}
                    >
                        ${years} ${years > 1 ? "years" : "year"} upfront
                        ${years > 1 ? `(${years} years warranty)` : ""}
                    </option>
                `);

            });

        }
        // ==========================================
        // UPDATE CURRENT SELECTION
        // ==========================================

        const current = document.getElementById("currentSelection");

        const totalPrice = Number(item.dataset.price);
        const frequency = Number(item.dataset.frequency || 1);

        const displayPrice =
            this.state.type === "onetime"
                ? totalPrice / 100
                : totalPrice / frequency / 100;

        current.dataset.variant  = item.dataset.variant;
        current.dataset.price    = displayPrice.toFixed(2);
        current.dataset.compare  = item.dataset.compare || "";
        current.dataset.handle   = item.dataset.handle || "";
        current.dataset.image    = item.dataset.image || "";
        current.dataset.stocknum = item.dataset.stocknum || 0;
        current.dataset.restock  = item.dataset.restock || "";

        $(".product-single__thumbnails-items").removeClass(" active");
        $(".product-single__thumbnails-items." + current.dataset.handle).addClass(" active");
        $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
        $(".product-single__thumbnails-items." + current.dataset.handle + " a").addClass(
            "active-thumb",
        );

        // refresh theme
        if (typeof updateLinks === "function") {
            updateLinks();
        }

        if (typeof updatePrice === "function") {
            updatePrice();
        }
        if (typeof updateInstallment === "function") {
            updateInstallment();
        }
        if (typeof updateThumbnail === "function") {
            updateThumbnail();
        }
        if (typeof updateStockIndicator === "function") {
            updateStockIndicator();
        }

    }

};

$(function () {

    RF.init();

});